const grid = {
  containerMaxWidth: 1415,
  rowMargin: '.5rem',
  gutterHalf: '.5rem',
};

export { grid };
